module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answers"
  }, [(_vm.answers.length) ? [_c('Pagination', {
    attrs: {
      "pages": _vm.pages
    },
    on: {
      "onPaginate": _vm.onPaginate
    }
  }), _vm._v(" "), _vm._l((_vm.answers), function(answer) {
    return _c('Item', {
      key: answer.id,
      ref: "items",
      refInFor: true,
      attrs: {
        "item": answer
      },
      on: {
        "onDelete": _vm.onDelete,
        "onFavorite": _vm.onFavorite,
        "onPlay": _vm.onPlay
      }
    })
  }), _vm._v(" "), _c('Pagination', {
    attrs: {
      "pages": _vm.pages
    },
    on: {
      "onPaginate": _vm.onPaginate
    }
  })] : [_c('ItemEmpty')]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c29808","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/questions/answers/index.vue
// module id = 463
// module chunks = 0 1